import React from "react";
import { Box } from "rebass/styled-components";
import styled, { css } from "styled-components";
import { ElementCardTeam } from "../ElementCard";
import { StyledShirt } from "../Shirt";
import { PrimaryGradient, VisuallyHidden } from "../Utils";

const StyledTeamElementGroup = styled.div<IStyledProps>`
  border-top: ${(props) => props.theme.borders[3]};
  border-bottom: ${(props) => props.theme.borders[3]};
  background-color: ${(props) => props.theme.colors.greyWhite};
  color: #000;

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    padding: 2px;
    border: 0;
    border-radius: ${(props) => props.theme.radii[1]};
    ${PrimaryGradient}
  }

  ${(props) =>
    props.isBench &&
    css`
      ${StyledShirt} {
        display: none;
      }

      ${ElementCardTeam} {
        margin-bottom: 0;
      }
    `}
`;

const TeamElementGroupTitle = styled.h3`
  margin: 0;
  font-family: ${(props) => props.theme.fonts.body};
  font-size: ${(props) => props.theme.fontSizes[3]};
  text-transform: capitalize;
  ${PrimaryGradient}
`;

const TeamElementGroupBody = styled.div<IStyledProps>`
  border-radius: 2px;
  background-color: #fff;
  padding: ${(props) => `${props.theme.space[3]} 0`};
`;

interface IStyledProps {
  isBench?: boolean;
}

interface IProps {
  isHiddenTitle?: boolean;
  title: React.ReactNode;
  children: React.ReactNode;
}

type Props = IProps & IStyledProps;

const TeamElementGroup: React.FC<Props> = ({
  children,
  isBench = false,
  isHiddenTitle = false,
  title,
}) => (
  <StyledTeamElementGroup isBench={isBench}>
    <TeamElementGroupTitle>
      {isHiddenTitle ? (
        <VisuallyHidden>{title}</VisuallyHidden>
      ) : (
        <Box p="0.4rem">{title}</Box>
      )}
    </TeamElementGroupTitle>
    <TeamElementGroupBody isBench={isBench}>{children}</TeamElementGroupBody>
  </StyledTeamElementGroup>
);

export default TeamElementGroup;
